import { Component } from "react";
import { DatePicker } from "@material-ui/pickers/DatePicker";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import TextField from "@material-ui/core/TextField";
import ApiButton from "../../../../shared/ui/Api.Button";
import MenuItem from "@material-ui/core/MenuItem";
import CurrencyFormater from "../../../../shared/ui/Currency.Input";

import TableNew, { CELL_TYPES } from "../../../../shared/Table";
import { numberWithoutSpaces } from "../../../../utilities/formaters";
import RefreshButton from "../../../../shared/ui/Refresh.Button";
import FactoringDetails from "./Factoring.Details";

import _ from "underscore";
import PropTypes from "prop-types";
import Checkbox from "@material-ui/core/Checkbox";
import { FormControlLabel } from "@material-ui/core";

import moment from "moment";

class FactoringComponent extends Component {
  constructor(props) {
    super(props);

    let columns = [
      { key: "Id", label: "Credit Id", visible: false, type: CELL_TYPES.text },
      {
        key: "AssetClass",
        label: "Asset Class",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "OriginatorCreditId",
        label: "Originator Credit Id",
        visible: true,
        type: CELL_TYPES.text,
      },
      { key: "Notes", label: "Name", visible: true, type: CELL_TYPES.text },
      {
        key: "IssueDate",
        label: "Issue Date",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "EndDate",
        label: "End Date",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "TotalPaid.Amount",
        label: "Total Paid",
        visible: false,
        type: CELL_TYPES.money,
      },
      {
        key: "CreditAmount.Amount",
        label: "Credit Amount",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "RemainingPrincipal.Amount",
        label: "Remaining Principal",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "CreditLoss.Amount",
        label: "Credit loss",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Originator",
        label: "Originator",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "NominalInterest.Value",
        label: "Nominal Interest",
        visible: true,
        type: CELL_TYPES.percentage,
      },
    ];

    let startingDate = new Date();
    startingDate.setHours(0, 0, 0, 0);

    this.state = {
      AssetClass: "",
      OriginatorId: "",
      EndDate: startingDate,
      IssueDate: startingDate,
      Principal: "",
      InterestRate: "",
      Country: "",
      OriginatorCreditId: "",
      Notes: "",
      FirstExpectedPaymentDate: startingDate,
      DaysBetweenPayments: null,
      IsBullet: false,
      BorrowerIdentifierType: "None",
      BorrowerIdentifier: "",
      SsnNationality: "",
      sending: false,
      columns,
    };
  }

  componentDidMount = () => {
    this.props.getFactoringApplications();
  };

  componentWillUnmount = () => {
    clearTimeout(this.timer);
  };

  sendData = () => {
    this.props.createFactoring({
      OriginatorId: this.state.OriginatorId,
      EndDate: moment(this.state.EndDate).format("YYYY-MM-DD"),
      IssueDate: moment(this.state.IssueDate).format("YYYY-MM-DD"),
      Principal: numberWithoutSpaces(this.state.Principal.replace(",", ".")),
      InterestRate: this.state.InterestRate,
      OriginatorCreditId: this.state.OriginatorCreditId,
      PaymentParams: {
        IsBullet: this.state.IsBullet,
        FirstExpectedPaymentDate:
          this.state.IsBullet !== true
            ? moment(this.state.FirstExpectedPaymentDate).format("YYYY-MM-DD")
            : null,
        DaysBetweenPayments:
          this.state.IsBullet !== true ? this.state.DaysBetweenPayments : null,
      },
      Country: this.state.Country,
      AssetClass: this.state.AssetClass,
      Notes: this.state.Notes,
      BorrowerIdentifierType: this.state.BorrowerIdentifierType,
      BorrowerIdentifier: this.state.BorrowerIdentifier,
      SsnNationality: this.state.SsnNationality,
    });

    this.setState({ sending: true });

    this.timer = setTimeout(() => {
      let startingDate = new Date();
      startingDate.setHours(0, 0, 0, 0);
      if (this.props.marketplace.factoring.applicationCreate.sent) {
        this.props.getFactoringApplications();
        this.setState({
          OriginatorId: "",
          EndDate: startingDate,
          IssueDate: startingDate,
          Principal: 0,
          InterestRate: 0,
          OriginatorCreditId: "",
          Country: "",
          AssetClass: "",
          Notes: "",
          BorrowerIdentifierType: "None",
          BorrowerIdentifier: "",
          sending: false,
        });
      } else {
        this.setState({ sending: false });
      }
    }, 750);
  };

  changeField = (name, event) => {
    var changeObject = {};
    changeObject[name] = event.target.value;

    this.setState({
      ...changeObject,
    });
  };

  changeOriginator = (event) => {
    let originator = _.find(this.props.marketplace.originators.data, (item) => {
      return item.Id == event.target.value;
    });

    if (originator.Name == "Credstep")
      // eslint-disable-next-line no-undef
      this.setState({ OriginatorId: value, Country: "", InterestRate: 9 });
    else if (originator.Name == "Samtrygg")
      // eslint-disable-next-line no-undef
      this.setState({ OriginatorId: value, Country: "", InterestRate: 6 });
    else this.setState({ OriginatorId: event.target.value, Country: "" });
  };

  changeCountry = (event) => {
    this.setState({ Country: event.target.value });
  };

  getOriginators = () => {
    return this.props.marketplace.originators.data.map((originator, index) => {
      if (this.containsSelectedAssetClass(originator.CountryAssetClasses))
        return (
          <MenuItem value={originator.Id} key={"orig-dropdown-" + index}>
            {originator.Name}
          </MenuItem>
        );
    });
  };

  containsSelectedAssetClass = (assetClasses) => {
    for (var i = 0; i < assetClasses.length; i++) {
      let found = _.find(assetClasses, (item) => {
        return item.AssetClass == this.state.AssetClass;
      });

      if (found) return true;
    }

    return false;
  };

  getOriginatorCountries = () => {
    let originator = _.find(this.props.marketplace.originators.data, (item) => {
      return item.Id == this.state.OriginatorId;
    });
    if (originator) {
      let countriesAssetClasses = _.uniq(
        originator.CountryAssetClasses,
        (item) => {
          return item.Country;
        },
      );
      return countriesAssetClasses.map((item, index) => {
        return (
          <MenuItem value={item.Country} key={"country-dropdown-" + index}>
            {item.Country}
          </MenuItem>
        );
      });
    }
  };

  changeEndDate = (date) => {
    this.setState({
      EndDate: date,
    });
  };

  changeAssetClass = (event) => {
    this.setState({
      AssetClass: event.target.value,
    });
  };

  changeIssueDate = (date) => {
    this.setState({
      IssueDate: date,
    });
  };

  changeFirstExpectedPaymentDate = (date) => {
    this.setState({
      FirstExpectedPaymentDate: date,
    });
  };

  changeBorrowerIdentifierType = (event) => {
    this.setState({
      BorrowerIdentifierType: event.target.value,
    });
  };

  changeSsnNationality = (event) => {
    this.setState({
      SsnNationality: event.target.value,
    });
  };

  changeIsBullet = () => {
    this.setState({
      IsBullet: !this.state.IsBullet,
    });
  };

  render() {
    return (
      <div className="marketplace-layout body-height content-padding">
        <Card>
          <CardHeader title="Create MPL" />
          {/** TODO EXPANDER */}
          <CardContent>
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4">
                    <TextField
                      size="small"
                      variant="outlined"
                      select
                      id="AssetClass"
                      label="Asset Class"
                      value={this.state.AssetClass}
                      onChange={this.changeAssetClass}
                      fullWidth={true}
                    >
                      <MenuItem
                        value={"Factoring"}
                        key={"AssetClass-dropdown-Factoring"}
                      >
                        Factoring
                      </MenuItem>
                      <MenuItem
                        value={"SMECredit"}
                        key={"AssetClass-dropdown-SME"}
                      >
                        SME
                      </MenuItem>
                      <MenuItem
                        value={"DcPortfolio"}
                        key={"AssetClass-dropdown-DCPortfolio"}
                      >
                        DC Portfolio
                      </MenuItem>
                    </TextField>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <TextField
                      size="small"
                      variant="outlined"
                      select
                      id="Originator-field"
                      label="Originator"
                      value={this.state.OriginatorId}
                      onChange={this.changeOriginator}
                      fullWidth={true}
                    >
                      {this.getOriginators()}
                    </TextField>
                  </div>

                  <div className="col-md-4">
                    <TextField
                      size="small"
                      variant="outlined"
                      select
                      id="Country-field"
                      label="Country"
                      value={this.state.Country}
                      onChange={this.changeCountry}
                      fullWidth={true}
                    >
                      {this.getOriginatorCountries()}
                    </TextField>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <CurrencyFormater
                      id="Principal-field"
                      label="Principal"
                      value={this.state.Principal}
                      onChange={this.changeField.bind(this, "Principal")}
                      fullWidth={true}
                    />
                  </div>
                  <div className="col-md-4">
                    <TextField
                      size="small"
                      variant="outlined"
                      id="InterestRate-field"
                      label="Interest to investors [%]"
                      value={this.state.InterestRate}
                      onChange={this.changeField.bind(this, "InterestRate")}
                      type="number"
                      step="1"
                      fullWidth={true}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <DatePicker
                      format={"MMMM Do YYYY"}
                      inputVariant="outlined"
                      className="small-datepicker"
                      id="IssueDate-field"
                      label="Issue Date"
                      value={this.state.IssueDate}
                      onChange={this.changeIssueDate}
                      fullWidth={true}
                    />
                  </div>
                  <div className="col-md-4">
                    <DatePicker
                      format={"MMMM Do YYYY"}
                      inputVariant="outlined"
                      className="small-datepicker"
                      id="EndDate-field"
                      label="EndDate Date"
                      value={this.state.EndDate}
                      onChange={this.changeEndDate}
                      fullWidth={true}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <TextField
                      size="small"
                      variant="outlined"
                      id="OriginatorCreditId-field"
                      label="Originator Credit Id"
                      value={this.state.OriginatorCreditId}
                      onChange={this.changeField.bind(
                        this,
                        "OriginatorCreditId",
                      )}
                      fullWidth={true}
                    />
                  </div>
                  <div className="col-md-4">
                    <TextField
                      size="small"
                      variant="outlined"
                      id="Notes-field"
                      label="Name"
                      value={this.state.Notes}
                      onChange={this.changeField.bind(this, "Notes")}
                      fullWidth={true}
                      multiLine={true}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <DatePicker
                      format={"MMMM Do YYYY"}
                      inputVariant="outlined"
                      className="small-datepicker"
                      id="FirstExpectedPaymentDate-field"
                      label="Expected first payment date"
                      value={this.state.FirstExpectedPaymentDate}
                      onChange={this.changeFirstExpectedPaymentDate}
                      fullWidth={true}
                      disabled={this.state.IsBullet}
                    />
                  </div>
                  <div className="col-md-4">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.IsBullet}
                          onClick={this.changeIsBullet}
                        />
                      }
                      label="Is Bullet"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <TextField
                      size="small"
                      variant="outlined"
                      id="DaysBetweenPayments-field"
                      label="Days between payments"
                      value={this.state.DaysBetweenPayments}
                      onChange={this.changeField.bind(
                        this,
                        "DaysBetweenPayments",
                      )}
                      type="number"
                      step="1"
                      fullWidth={true}
                      disabled={this.state.IsBullet}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <center>
                      <p>
                        Fill debtor info below if consider exposure across
                        credits
                      </p>
                    </center>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <TextField
                      size="small"
                      variant="outlined"
                      select
                      id="BorrowerIdentifierType-field"
                      label="Borrower Type"
                      value={this.state.BorrowerIdentifierType}
                      onChange={this.changeBorrowerIdentifierType}
                      fullWidth={true}
                    >
                      <MenuItem value={"None"}>None</MenuItem>
                      <MenuItem value={"Ssn"}>SSN</MenuItem>
                      <MenuItem value={"OrgNumber"}>Org Number</MenuItem>
                    </TextField>
                  </div>
                  <div className="col-md-4">
                    <TextField
                      size="small"
                      variant="outlined"
                      id="BorrowerIdentifier-field"
                      label="Borrower (ssn / orgno)"
                      value={this.state.BorrowerIdentifier}
                      onChange={this.changeField.bind(
                        this,
                        "BorrowerIdentifier",
                      )}
                      fullWidth={true}
                      multiLine={true}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4" />
                  <div className="col-md-4">
                    <TextField
                      size="small"
                      variant="outlined"
                      select
                      id="SsnNationalityType-field"
                      label="Ssn Nationality"
                      value={this.state.SsnNationality}
                      onChange={this.changeSsnNationality}
                      fullWidth={true}
                    >
                      <MenuItem value={""}>None</MenuItem>
                      <MenuItem value={"1"}>Sweden</MenuItem>
                      <MenuItem value={"2"}>Finland</MenuItem>
                    </TextField>
                  </div>
                </div>
                <ApiButton
                  buttonLabel={"Create MPL"}
                  sending={
                    this.props.marketplace.factoring.applicationCreate.sending
                  }
                  sent={this.props.marketplace.factoring.applicationCreate.sent}
                  error={
                    this.props.marketplace.factoring.applicationCreate.error
                  }
                  onButtonClick={this.sendData}
                />
              </div>
            </div>
          </CardContent>
          <CardContent>
            <div className="row">
              <div className="col-md-12">
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <RefreshButton
                  onRefreshClick={this.props.getFactoringApplications}
                />
                <TableNew
                  {...this.props}
                  columns={this.state.columns}
                  items={this.props.marketplace.factoring.application.data}
                  tableKey={"factoring"}
                  showDetails={true}
                  detailsRenderer={(item, expanded) => {
                    return <FactoringDetails item={item} expanded={expanded} />;
                  }}
                />
              </div>
            </div>
          </CardContent>
        </Card>
        <p />
      </div>
    );
  }

  static propTypes = {
    createFactoring: PropTypes.func.isRequired,
    changeFactoringListPage: PropTypes.func.isRequired,
    changeFactoringListFilter: PropTypes.func.isRequired,
    getFactoringApplications: PropTypes.func.isRequired,
    marketplace: PropTypes.object.isRequired,
  };
}
export default FactoringComponent;
